<div #blockBody class="external-match-best-bet" class="{{ displayMode }}">
	<div class="match-page-loading" *ngIf="gamesLoading && !gamesError">
		<span>
			Loading<span class="animated-ellipsis"><span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></span>
		</span>
	</div>
	<div class="match-page-loading" *ngIf="gamesError">
		<span class="error-main">
			<span>
				We are having trouble loading {{ localisationService.localeTerm('match', '') }} data
			</span>
		</span>

		<span>
			Please
			<span class="retry-link"
				(click)="reloadSingleGame(configurationObject.matchID)">
				try again
			</span>
		</span>
	</div>
	<div class="match-page-tabs" *ngIf="!gamesLoading && !gamesError">
		<div class="match-page-tab-selector">
			<div class="tab-option selected-option">
				<span *ngIf="!showBestParlay && !bestBetError">
                    {{ betService.bestBetName(match.aggregatedBestBets[0], match.MatchData.Sport) }}
                </span>
				<span *ngIf="showBestParlay && !bestBetError">
					Same {{ localisationService.localeTerm((match.MatchData.Sport | lowercase) === 'ten' ? 'match_tennis' : 'match', 'title-case') }} Parlay
				</span>
			</div>
		</div>
		<div class="match-page-tab best-bets">
			<div class="best-bets-ctr large-only">
				<div class="main-column no-margin">
					<div class="bet-error" *ngIf="bestBetError">
						No bets of this type available
					</div>
					<div class="bet-box" *ngIf="!showBestParlay && !bestBetError" [class]="match.aggregatedBestBets[0].bookmaker">
						<div class="team-icon-ctr">
							<div class="team-row">
								<app-team-icon class="team-logo"
									[sportCode]="match.MatchData.Sport"
                                    [team]="awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam"
                                ></app-team-icon>
								<span>
                                    {{ generalService.teamNameDisplay(awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam) }}
                                </span>
							</div>
							<div class="team-row">
								<app-team-icon class="team-logo"
									[sportCode]="match.MatchData.Sport"
                                    [team]="awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                                ></app-team-icon>
								<span>
                                    {{ generalService.teamNameDisplay(awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
                                </span>
							</div>
						</div>

						<div class="bet-name">
							<div class="value-indi" *ngIf="betService.valueFireOpacity(match.aggregatedBestBets[0].edge) > 0"
								[style.opacity]="betService.valueFireOpacity(match.aggregatedBestBets[0].edge)">
								<div class="value-icon" aria-label="Value Identified" role="note"></div>
							</div>

							<span *ngIf="match.aggregatedBestBets[0].type === 'line'">
								{{ generalService.teamNameDisplay(match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
								{{ match.aggregatedBestBets[0].lineValue >= 0 ? '+' : '' }}{{ match.aggregatedBestBets[0].lineValue | number: '1.1-1' }}
							</span>

							<span *ngIf="match.aggregatedBestBets[0].type === 'total'">
								{{ match.aggregatedBestBets[0].bet === 'over' ? 'Over' : 'Under' }}
								{{ match.aggregatedBestBets[0].markValue }}
							</span>

							<app-team-icon *ngIf="match.aggregatedBestBets[0].type === 'h2h'"
								[sportCode]="match.MatchData.Sport"
                                [team]="match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                            ></app-team-icon>

							<span *ngIf="match.aggregatedBestBets[0].type === 'h2h'">
								{{ generalService.teamNameDisplay(match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }} win
							</span>

							<span *ngIf="match.aggregatedBestBets[0].type === 'bts'">
								{{ match.aggregatedBestBets[0].bet === 'yes' ? 'Yes' : 'No' }}
							</span>
						</div>

						<div class="odds-line" *ngIf="!configurationObject.oddsInsideBetButton">
							{{ betService.formatOdds(match.aggregatedBestBets[0].odds) }}
						</div>

						<div class="links-ctr">
							<a class="bet-button"
								[style.backgroundColor]="match.aggregatedBestBets[0].bookmaker | bookBackgroundColour"
								[style.color]="match.aggregatedBestBets[0].bookmaker | bookForegroundColour"
								[href]="betService.bookmakerLink(match.aggregatedBestBets[0].bookmaker, match.aggregatedBestBets[0].linkDetails)"
								target="_blank"
								attr.data-recording-click-props='{
									"odds-bookmaker": "{{ match.aggregatedBestBets[0].bookmaker }}",
									"odds-match": "{{ match.MatchData.SIMatchID }}",
									"odds-path": "{{ document?.location.pathname }}",
									"odds-component": "match-best-bet",
									"odds-sport": "{{ match.MatchData.Sport }}",
									"odds-type": "{{ match.aggregatedBestBets[0].type }}",
									"odds-option": "{{ match.aggregatedBestBets[0].bet === "away"
										? (match.MatchData.Sport === "TEN" ? match.MatchData.PlayerData.player2.nameDetails.first + " " + match.MatchData.PlayerData.player2.nameDetails.last : match.MatchData.AwayTeam.Abv)
										: (match.aggregatedBestBets[0].bet === "home" ? (match.MatchData.Sport === "TEN" ? match.MatchData.PlayerData.player1.nameDetails.first + " " + match.MatchData.PlayerData.player1.nameDetails.last : match.MatchData.HomeTeam.Abv) : match.aggregatedBestBets[0].bet) }}",
									"odds-value": {{ match.aggregatedBestBets[0].odds }}
								}'
								rel="noreferrer">
								<img loading="lazy"
									class="bookie-icon-white"
									*ngIf="match.aggregatedBestBets[0].bookmaker !== 'tab'"
									[src]="match.aggregatedBestBets[0].bookmaker | bookIconAlt"
									[alt]="betService.stylisedBookName(match.aggregatedBestBets[0].bookmaker)"
								>
								<span *ngIf="!configurationObject.oddsInsideBetButton">
                                    {{ localisationService.localeTerm('bet_button_cta', 'title-case') }}
                                </span>
								<span *ngIf="configurationObject.oddsInsideBetButton">
                                    {{ betService.formatOdds(match.aggregatedBestBets[0].odds) }}
                                </span>
							</a>

							<a class="matchup-link" *ngIf="generalService.getMatchLink(match.MatchData.SIMatchID)" [href]="generalService.getMatchLink(match.MatchData.SIMatchID)">
								See Matchup
							</a>
						</div>
					</div>


					<div class="bet-box parlay" *ngIf="showBestParlay && !bestBetError" [class]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0])">

						<div class="team-icon-ctr">
							<div class="team-row">
								<app-team-icon class="team-logo"
									[sportCode]="match.MatchData.Sport"
                                    [team]="awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam"
                                ></app-team-icon>
								<span>
                                    {{ generalService.teamNameDisplay(awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam) }}
                                </span>
							</div>
							<div class="team-row">
								<app-team-icon class="team-logo"
									[sportCode]="match.MatchData.Sport"
                                    [team]="awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                                ></app-team-icon>
								<span>
                                    {{ generalService.teamNameDisplay(awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
                                </span>
							</div>
						</div>

						<div class="bet-list-ctr">
							<!-- <div class="value-indi" *ngIf="betService.valueFireOpacity(match.aggregatedBestParlay.edge) > 0"
								[style.opacity]="betService.valueFireOpacity(match.aggregatedBestParlay.edge)">
								<div class="value-icon" aria-label="Value Identified" role="note"></div>
							</div> -->
							<div class="leg-row" *ngFor="let bet of match.aggregatedBestParlay.elements; first as first">
								<div class="parlay-plus" *ngIf="!first">
									<fa-icon [icon]="faPlus"></fa-icon>
								</div>
								<span *ngIf="bet.type === 'line'">
									{{ generalService.teamNameDisplay(bet.bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
									{{ bet.lineValue >= 0 ? '+' : '' }}{{ bet.lineValue | number: '1.1-1' }}
								</span>

								<span *ngIf="bet.type === 'total'">
									{{ bet.bet === 'over' ? 'Over' : 'Under' }}
									{{ bet.markValue }}
								</span>
								
								<app-team-icon class="team-logo" *ngIf="bet.type === 'h2h'"
									[sportCode]="match.MatchData.Sport"
                                    [team]="bet.bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                                ></app-team-icon>

								<span *ngIf="bet.type === 'h2h'">
									
									{{ generalService.teamNameDisplay(bet.bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }} win
								</span>

								<span *ngIf="bet.type === 'bts'">
									{{ bet.bet === 'yes' ? 'Yes' : 'No' }}
								</span>
							</div>
						</div>

						<!-- <div class="odds-line" *ngIf="!configurationObject.oddsInsideBetButton">
							{{ betService.formatOdds(match.aggregatedBestParlay.totalOdds, configurationObject) }}
						</div> -->

						<div class="links-ctr">
							<a class="bet-button"
								[style.backgroundColor]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookBackgroundColour"
								[style.color]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookForegroundColour"
								[href]="betService.bookmakerLink((configurationObject.bookmakerTheme || configurationObject.bookmakers[0]), configurationObject)"
								target="_blank"
								rel="noreferrer"
								attr.data-recording-click-props='{
									"odds-bookmaker": "{{ configurationObject.bookmakerTheme || configurationObject.bookmakers[0] }}",
									"odds-match": "{{ match.MatchData.SIMatchID }}",
									"odds-path": "{{ document?.location.pathname }}",
									"odds-component": "match-best-bet",
									"odds-sport": "{{ match.MatchData.Sport }}",
									"odds-type": "multi"
								}'>
								<img loading="lazy"
									class="bookie-icon-white"
									*ngIf="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) !== 'tab'"
									[src]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookIconAlt"
									[alt]="betService.stylisedBookName(configurationObject.bookmakerTheme || configurationObject.bookmakers[0])"
								>
								{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}
								<!-- <span *ngIf="configurationObject.oddsInsideBetButton">{{ betService.formatOdds(match.aggregatedBestParlay.totalOdds, configurationObject) }}</span> -->
							</a>

							<a class="matchup-link" *ngIf="generalService.getMatchLink(match.MatchData.SIMatchID)" [href]="generalService.getMatchLink(match.MatchData.SIMatchID)">
								See Matchup
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="best-bets-ctr compact-only">
				<div class="bet-error" *ngIf="bestBetError">
					No bets of this type available
				</div>
				<div class="bet-box" *ngIf="!showBestParlay && !bestBetError" [class]="match.aggregatedBestBets[0].bookmaker">

					<div class="team-icon-row">
						<app-team-icon class="team-logo"
							[sportCode]="match.MatchData.Sport"
                            [team]="awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam"
                        ></app-team-icon>
						<div class="vs-sep">
							<span>vs.</span>
						</div>
						<app-team-icon class="team-logo"
							[sportCode]="match.MatchData.Sport"
                            [team]="awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                        ></app-team-icon>
					</div>

					<div class="bet-name">
						<div class="value-indi" *ngIf="betService.valueFireOpacity(match.aggregatedBestBets[0].edge) > 0"
							[style.opacity]="betService.valueFireOpacity(match.aggregatedBestBets[0].edge)">
							<div class="value-icon" aria-label="Value Identified" role="note"></div>
						</div>

						<span *ngIf="match.aggregatedBestBets[0].type === 'line'">
							{{ generalService.teamNameDisplay(match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
							{{ match.aggregatedBestBets[0].lineValue >= 0 ? '+' : '' }}{{ match.aggregatedBestBets[0].lineValue | number: '1.1-1' }}
						</span>

						<span *ngIf="match.aggregatedBestBets[0].type === 'total'">
							{{ match.aggregatedBestBets[0].bet === 'over' ? 'Over' : 'Under' }}
							{{ match.aggregatedBestBets[0].markValue }}
						</span>

						<app-team-icon *ngIf="match.aggregatedBestBets[0].type === 'h2h'"
							[sportCode]="match.MatchData.Sport"
                            [team]="match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                        ></app-team-icon>

						<span *ngIf="match.aggregatedBestBets[0].type === 'h2h'">
							{{ generalService.teamNameDisplay(match.aggregatedBestBets[0].bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }} win
						</span>

						<span *ngIf="match.aggregatedBestBets[0].type === 'bts'">
							{{ match.aggregatedBestBets[0].bet === 'yes' ? 'Yes' : 'No' }}
						</span>
					</div>

					<div class="odds-line" *ngIf="!configurationObject.oddsInsideBetButton">
						{{ betService.formatOdds(match.aggregatedBestBets[0].odds) }}
					</div>

					<div class="links-ctr">
						<a class="bet-button"
							[style.backgroundColor]="match.aggregatedBestBets[0].bookmaker | bookBackgroundColour"
							[style.color]="match.aggregatedBestBets[0].bookmaker | bookForegroundColour"
							[href]="betService.bookmakerLink(match.aggregatedBestBets[0].bookmaker, match.aggregatedBestBets[0].linkDetails)"
							target="_blank"
							attr.data-recording-click-props='{
								"odds-bookmaker": "{{ match.aggregatedBestBets[0].bookmaker }}",
								"odds-match": "{{ match.MatchData.SIMatchID }}",
								"odds-path": "{{ document?.location.pathname }}",
								"odds-component": "match-best-bet",
								"odds-sport": "{{ match.MatchData.Sport }}",
								"odds-type": "{{ match.aggregatedBestBets[0].type }}",
								"odds-option": "{{ match.aggregatedBestBets[0].bet === "away"
									? (match.MatchData.Sport === "TEN" ? match.MatchData.PlayerData.player2.nameDetails.first + " " + match.MatchData.PlayerData.player2.nameDetails.last : match.MatchData.AwayTeam.Abv)
									: (match.aggregatedBestBets[0].bet === "home" ? (match.MatchData.Sport === "TEN" ? match.MatchData.PlayerData.player1.nameDetails.first + " " + match.MatchData.PlayerData.player1.nameDetails.last : match.MatchData.HomeTeam.Abv) : match.aggregatedBestBets[0].bet) }}",
								"odds-value": {{ match.aggregatedBestBets[0].odds }}
							}'
							rel="noreferrer">
							<img loading="lazy"
								class="bookie-icon-white"
								*ngIf="match.aggregatedBestBets[0].bookmaker !== 'tab'"
								[src]="match.aggregatedBestBets[0].bookmaker | bookIconAlt"
								[alt]="betService.stylisedBookName(match.aggregatedBestBets[0].bookmaker)"
							>
							<span *ngIf="!configurationObject.oddsInsideBetButton">
                                {{ localisationService.localeTerm('bet_button_cta', 'title-case') }}
                            </span>
							<span *ngIf="configurationObject.oddsInsideBetButton">
                                {{ betService.formatOdds(match.aggregatedBestBets[0].odds) }}
                            </span>
						</a>

						<a class="matchup-link" *ngIf="generalService.getMatchLink(match.MatchData.SIMatchID)" [href]="generalService.getMatchLink(match.MatchData.SIMatchID)">
							See Matchup
						</a>
					</div>
				</div>
				
				
				<div class="bet-box parlay" *ngIf="showBestParlay && !bestBetError" [class]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0])">

					<div class="team-icon-row">
						<app-team-icon class="team-logo"
							[sportCode]="match.MatchData.Sport"
                            [team]="awayBeforeHome ? match.MatchData.AwayTeam : match.MatchData.HomeTeam"
                        ></app-team-icon>
						<div class="vs-sep">
							<span>vs.</span>
						</div>
						<app-team-icon class="team-logo"
							[sportCode]="match.MatchData.Sport"
                            [team]="awayBeforeHome ? match.MatchData.HomeTeam : match.MatchData.AwayTeam"
                        ></app-team-icon>
					</div>

					<div class="bet-plus-pair" *ngFor="let bet of match.aggregatedBestParlay.elements; last as last">
						<div class="bet-name">

							<span *ngIf="bet.type === 'line'">
								{{ generalService.teamNameDisplay(bet.bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }}
								{{ bet.lineValue >= 0 ? '+' : '' }}{{ bet.lineValue | number: '1.1-1' }}
							</span>

							<span *ngIf="bet.type === 'total'">
								{{ bet.bet === 'over' ? 'Over' : 'Under' }}
								{{ bet.markValue }}
							</span>

							<span *ngIf="bet.type === 'h2h'">
								{{ generalService.teamNameDisplay(bet.bet === 'home' ? match.MatchData.HomeTeam : match.MatchData.AwayTeam) }} win
							</span>

							<span *ngIf="bet.type === 'bts'">
								{{ bet.bet === 'yes' ? 'Yes' : 'No' }}
							</span>
						</div>

						<div class="parlay-plus" *ngIf="!last">
							<fa-icon [icon]="faPlus"></fa-icon>
						</div>
					</div>

					

					<!-- <div class="odds-line" *ngIf="!configurationObject.oddsInsideBetButton">
						<div class="value-indi" *ngIf="betService.valueFireOpacity(match.aggregatedBestParlay.edge) > 0"
							[style.opacity]="betService.valueFireOpacity(match.aggregatedBestParlay.edge)">
							<div class="value-icon" aria-label="Value Identified" role="note"></div>
						</div>
						{{ betService.formatOdds(match.aggregatedBestParlay.totalOdds, configurationObject) }}
					</div> -->

					<div class="links-ctr">
						<a class="bet-button"
							[style.backgroundColor]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookBackgroundColour"
							[style.color]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookForegroundColour"
							[href]="betService.bookmakerLink((configurationObject.bookmakerTheme || configurationObject.bookmakers[0]), configurationObject)"
							target="_blank"
							attr.data-recording-click-props='{
								"odds-bookmaker": "{{ configurationObject.bookmakerTheme || configurationObject.bookmakers[0] }}",
								"odds-match": "{{ match.MatchData.SIMatchID }}",
								"odds-path": "{{ document?.location.pathname }}",
								"odds-component": "match-best-bet",
								"odds-sport": "{{ match.MatchData.Sport }}",
								"odds-type": "multi"
							}'
							rel="noreferrer">
							<img loading="lazy"
								class="bookie-icon-white"
								*ngIf="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) !== 'tab'"
								[src]="(configurationObject.bookmakerTheme || configurationObject.bookmakers[0]) | bookIconAlt"
								[alt]="betService.stylisedBookName(configurationObject.bookmakerTheme || configurationObject.bookmakers[0])"
							>
							{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}
							<!-- <span *ngIf="configurationObject.oddsInsideBetButton">
                                {{ betService.formatOdds(match.aggregatedBestParlay.totalOdds, configurationObject) }}
                            </span> -->
						</a>

						<a class="matchup-link" *ngIf="generalService.getMatchLink(match.MatchData.SIMatchID)" [href]="generalService.getMatchLink(match.MatchData.SIMatchID)">
							See Matchup
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
